import { useCallback } from "react";

import { Action, Marker, MarkerType, StencilType } from "../../types";
import { createNewBall, frameStencilController } from "../../utils";
import { UpdateFrameStencils } from "./use-update-frame-stencils";

export interface AddStencilProps {
  stencil: Action | Marker;
}
export type AddStencilFunc = (props: AddStencilProps) => void;
export const useAddStencil = (updateFrameStencils: UpdateFrameStencils): AddStencilFunc => {
  return useCallback<AddStencilFunc>(
    ({ stencil }) => {
      // frame stencils set state
      updateFrameStencils((prevState) => {
        const ballStencil =
          stencil.stencilType === StencilType.MARKER && stencil.markerType === MarkerType.PLAYER && stencil.possession
            ? createNewBall({ pos: stencil.pos, associatedPlayer: stencil.id })
            : null;

        return [stencil, ...(ballStencil ? [ballStencil] : [])].reduce(
          (acc, stencil) => frameStencilController({ operation: "ADD", stencils: acc, stencil }),
          prevState
        );
      });
    },
    [updateFrameStencils]
  );
};
